import React, { useEffect } from "react";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStats";
import { useDispatch } from "react-redux";
import { getMyRelations } from "../../../Redux/actions/Relations";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DrawerListItem from "../Components/DrawerListItem";
import SectionLabel from "../Components/SectionLabel";
import GlobalDrawerItems from "./GlobalDrawerItems";

const ParentDrawer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyRelations());
  }, [dispatch]);

  return (
    <div>
      <SectionLabel>Overview</SectionLabel>
      <DrawerListItem
        name="Dashboard"
        path="parentDashboard"
        Icon={DashboardOutlinedIcon}
      />

      <SectionLabel>Discover</SectionLabel>
      <GlobalDrawerItems />

      <SectionLabel>Family</SectionLabel>
      <DrawerListItem
        name="Bookings"
        path="bookings"
        Icon={DateRangeOutlinedIcon}
      />
      <DrawerListItem
        name="Stats"
        path="ParentViewStudentStats"
        Icon={QueryStatsOutlinedIcon}
      />
    </div>
  );
};

export default ParentDrawer;
